import { registerComponent } from "helpers";
import { WYATTElement } from "wyatt";

registerComponent(
  "search-results-count",
  class SearchResultsCount extends WYATTElement {
    constructor() {
      super();

      this.endpoint = this.dataset.resultsCount;
    }

    connectedCallback() {
      this.renderResultsCount();
    }

    renderResultsCount() {
      fetch(this.endpoint)
        .then((response) => response.json())
        .then((data) => {
          this.innerHTML = `(${data.results_count})`;
          this.removeAttribute("hidden");
        });
    }
  }
);
